import React, { useEffect, useState } from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import MapSearch from "../../components/LocationSearchByGoogle";
import DirectionsMapComp from "../../components/DirectionsMap";
import DropAreaItenary from "./Board2";
import { getMapPins } from "../../redux/slices/mapPins";
import { useSelector, useDispatch } from "react-redux";
import {
  getTripResults,
  setTripResults,
  UpdateTripResults,
} from "../../redux/slices/trips";
import SearchIcon from "@mui/icons-material/Search";
import { axios } from "../../utils/axios";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
const ViewTrips = ({ tripId, geoLoation }) => {
  const [mapCenter, setMapCenter] = useState(
    geoLoation || {
      lat: 31.06339829204645,
      lng: -97.82153183960645,
    }
  );
  const [mapZoom, setMapZoom] = useState(17);
  const [allTags, setAllTags] = useState([]);
  const [expandtags, setExpandTags] = useState(false);
  const { loading, error, mapResults } = useSelector((state) => state.pins);
  const { tripResults } = useSelector((state) => state.trips);
  const { tags } = useSelector((state) => state.pins);
  const [placeId, setPlaceId] = useState("");
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND + "pins/getalltags")
      .then((resp) => {
        setAllTags(resp.data.data);
      })
      .catch((err) => console.log(err));
  }, [tags]);
  const dispatch = useDispatch();
  const handlePlaceSelect = (lat, lng) => {
    setMapCenter({ lat, lng, load: true });
  };
  useEffect(() => {
    dispatch(getMapPins({ tripId }));
    dispatch(getTripResults({ tripId }));
    setTripResults(tripResults);
  }, []);

  const DraggablePin = ({ pin }) => {
    const [{ isDragging }, drag] = useDrag(() => ({
      type: "pin",
      item: pin,
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }));

    return (
      <div
        ref={drag}
        style={{
          opacity: isDragging ? 0.5 : 1,
          cursor: "move",
          border: "1px solid var(--light-grey)",
          borderRadius: "50px",
          padding: "2px 12px",
          background: "var(--white-color)",
        }}
        className="fs-8 "
      >
        {pin.name}
      </div>
    );
  };
  const DropArea = ({ onDrop, atd }) => {
    const [{ isOver }, drop] = useDrop(() => ({
      accept: "pin", // Only accept items of type "PIN"
      drop: (item) => onDrop(item, atd), // Handle drop event
      collect: (monitor) => ({
        isOver: monitor.isOver(),
      }),
    }));

    return (
      <div ref={drop} key={atd.id}>
        <DropAreaItenary
          key={atd.id}
          atd={atd && atd}
          onDrop={handleDrop}
          tripId={tripId}
        />
      </div>
    );
  };

  const handleDrop = async (item, atd) => {
    if (item.type === "pin") {
      const updatedTripDetails = tripResults.map((tripDetail) => {
        const updatedTripIternery = tripDetail.tripItinerary.filter(
          (itineraryItem) => itineraryItem._id !== item._id
        );
        return {
          ...tripDetail,
          tripItinerary: updatedTripIternery,
        };
      });

      const finalTripDetails = updatedTripDetails.map((tripDetail) => {
        if (tripDetail._id === atd._id) {
          return {
            ...tripDetail,
            tripItinerary: [
              { ...item, date: tripDetail.date },
              ...tripDetail.tripItinerary,
            ],
          };
        }
        return tripDetail;
      });
      const data = {
        tripId: tripId,
        itinerary: finalTripDetails,
      };
      await dispatch(UpdateTripResults({ data }));

      dispatch(getMapPins({ tripId }));
    }
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="row">
        <div
          className="col-md-5 order-md-1 order-2 "
          style={{ overflowY: "auto", maxHeight: "100vh" }}
        >
          <div
            className="d-flex align-items-center flex-wrap mt-4 "
            style={{ gap: "10px" }}
          >
            {mapResults &&
              mapResults.map((p, index) =>
                !p?.date && p?.tripId !== null ? (
                  <DraggablePin key={p.id} pin={p} />
                ) : null
              )}
          </div>
          {tripResults &&
            tripResults.map((atd, index) => (
              <DropArea onDrop={handleDrop} key={index} atd={atd} />
            ))}
        </div>
        <div
          className="col-md-7  mt-3  order-1 "
          style={{
            position: "sticky",
            top: "0",
            height: "88vh",
          }}
        >
          {!loading && (
            <div>
              <div
                style={{
                  transition: "height 0.3s ease",
                  height: expandtags === true ? "auto" : "25px",
                }}
                className=" mt-4 bxShadow hmap-cont "
              >
                <button
                  className="toggle-button w100 fw-600"
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    marginRight: "8px",
                  }}
                  onClick={() => setExpandTags((prev) => !prev)}
                >
                  {expandtags === true ? (
                    <div className="d-flex align-items-center  justify-content-center">
                      {" "}
                      Bucketlist <ArrowUpwardIcon
                        style={{ width: "18px" }}
                      />{" "}
                    </div>
                  ) : (
                    <div
                      div
                      className="d-flex align-items-center justify-content-center"
                    >
                      {" "}
                      Bucketlist <ArrowDownwardIcon
                        style={{ width: "18px" }}
                      />{" "}
                    </div>
                  )}
                </button>

                {allTags &&
                  allTags.map((item, index) => (
                    <div
                      style={{
                        borderBottom: "1px solid var(--light-grey)",
                        padding: "12px",
                        fontSize: "14px",
                      }}
                      key={index}
                      className="c-pointer d-flex align-items-center pin-hover-home"
                      onClick={() => {
                        setMapCenter({
                          lat: item?.pins[0]?.lat,
                          lng: item?.pins[0]?.lng,
                        });
                        // setMapZoom(17);
                      }}
                    >
                      <p className="ms-2">{item.name}</p>
                    </div>
                  ))}
              </div>
              <div
                className="bxShadow mx-auto w70 d-flex align-items-center mapserach justify-content-between"
                style={{
                  background: "#FFF",
                  position: "relative",
                  zIndex: 1000,
                  top: 32,
                  borderRadius: 8,
                  gap: 18,
                }}
              >
                <div className="  w100">
                  <MapSearch
                    onPlaceSelect={handlePlaceSelect}
                    onselect={(id) => setPlaceId(id)}
                  />
                </div>
                <SearchIcon
                  style={{ paddingRight: "10px", color: "var(--grey-color)" }}
                />
              </div>

              <DirectionsMapComp
                tripId={tripId}
                markerData={mapResults || []}
                searchLocation={mapCenter}
                zoom={mapZoom || 17}
                showDirections={true}
                styles={{ height: "88vh" }}
                disablePinsMarking={false}
                placeDetails={placeId}
              />
            </div>
          )}
        </div>
      </div>
    </DndProvider>
  );
};

export default ViewTrips;
